import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(gpx)/section/grinsper-hero-header.tsx");
